module.exports = __webpack_public_path__ + "img/big-classify-001.43fcbac6.png";